import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cv-templetes',
  templateUrl: './cv-templetes.component.html',
  styleUrls: ['./cv-templetes.component.css'],
})
export class CvTempletesComponent {
  @Input() formGroup!: FormGroup;

  cvTempletes = [
    {
      image: './assets/img/cv-templetes/current-cv.png',
      name: 'first-Template',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete2.png',
      name: 'second-template',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete3.png',
      name: 'third-template',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete4.png',
      name: 'fourth-template',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete5.png',
      name: 'fifth-template',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete7.png',
      name: 'cvTemplate6',
      isActive: true,
    },
    { image: './assets/img/cv-templetes/2.png', isActive: false },
    { image: './assets/img/cv-templetes/1.png', isActive: false },
    { image: './assets/img/cv-templetes/3.png', isActive: false },
    { image: './assets/img/cv-templetes/4.png', isActive: false },
    { image: './assets/img/cv-templetes/5.png', isActive: false },
    { image: './assets/img/cv-templetes/6.png', isActive: false },
    { image: './assets/img/cv-templetes/7.png', isActive: false },
    { image: './assets/img/cv-templetes/8.png', isActive: false },
    { image: './assets/img/cv-templetes/9.png', isActive: false },
    { image: './assets/img/cv-templetes/10.png', isActive: false },
    { image: './assets/img/cv-templetes/11.png', isActive: false },
    { image: './assets/img/cv-templetes/12.png', isActive: false },
  ];

  selectedName!: string;
  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  ngOnInit() {
    if (this.formGroup) {
      this.selectedName = this.formGroup.get('cvTempleteFile')?.value;

      let formData: any = localStorage.getItem('cvFormData');
      formData = JSON.parse(formData);

      // If no template is selected, select the first one by default
      if (!this.selectedName) {
        const firstActiveTemplate = this.cvTempletes.find((t) => t.isActive);
        if (firstActiveTemplate && firstActiveTemplate.name) {
          this.selectCv(firstActiveTemplate.name);
        }
      }
    }
  }

  selectCv(name: string) {
    this.selectedName = name;

    this.formGroup.get('cvTempleteFile')?.setValue(name);
    this.formGroup.get('cvTempletePath')?.setValue(name);

    // Mark as touched to trigger validation
    this.formGroup.get('cvTempleteFile')?.markAsTouched();
    this.formGroup.get('cvTempletePath')?.markAsTouched();
  }

  onNext() {
    if (!this.selectedName) {
      alert('Please select a CV template');
      return;
    }
    let formData: any = localStorage.getItem('cvFormData');
    formData = JSON.parse(formData);
    if (formData.editMode && formData.editMode == true) {
      this.next.emit();
    }

    this.next.emit();
  }

  onPrevious() {
    this.previous.emit();
  }
}
